export default [
  { url: "/home", text: "Home" },
  { url: "/about-me", text: "About Me" },
  { url: "/rock-paper-scissors", text: "Rock, Paper or Scissors" },
  { url: "https://www.google.com", text: "Google", external: true }
];